module.exports = __webpack_public_path__ + "static/media/github.6e11909c.svg";